// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-portal {
  position: absolute;
  background: white;
  border: 1px solid #cbd5e0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.dropdown-portal__list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.dropdown-portal__option {
  display: block;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: white;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  border-bottom: 1px solid #f1f5f9;
}

.dropdown-portal__option:hover {
  background: #f7fafc;
}

.dropdown-portal__option.active {
  background: #edf2f7;
  font-weight: 500;
}

.dropdown-portal__option:last-child {
  border-bottom: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/DropdownPortal/DropdownPortal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".dropdown-portal {\n  position: absolute;\n  background: white;\n  border: 1px solid #cbd5e0;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n}\n\n.dropdown-portal__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.dropdown-portal__option {\n  display: block;\n  width: 100%;\n  padding: 12px 16px;\n  border: none;\n  background: white;\n  text-align: left;\n  cursor: pointer;\n  font-size: 14px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.dropdown-portal__option:hover {\n  background: #f7fafc;\n}\n\n.dropdown-portal__option.active {\n  background: #edf2f7;\n  font-weight: 500;\n}\n\n.dropdown-portal__option:last-child {\n  border-bottom: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
